module.exports = {"430671001":"天问街道","430671101":"营田镇","430671102":"河市镇","430671203":"凤凰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430671.json
// module id = 1992
// module chunks = 0